import React, { useState } from 'react';
import styles from "./branchorder.module.css";
import { postFetch } from '../../../fetch/fetch';
import { toast } from 'react-toastify';
import { splitName } from './shared';
import { parseCoupang, SERVER_ERRORS } from './addproductmodal';

// 관리자 물품 수정 — 옵션 링크·물품명·옵션 (판매 중단 시 대체 상품으로 교체)
// 옵션 ID 는 추가와 같은 규칙으로 필수. 링크의 ID 가 바뀌면 서버가 PK 와 지점 숨김 설정을 같이 옮긴다
const EditProductModal: React.FC<any> = (props: any) => {

    const item: any = props.item;
    const [initName, initOption] = splitName(item.name);
    const [url, setUrl] = useState(item.url || "");
    const [manualId, setManualId] = useState("");
    const [name, setName] = useState(initName);
    const [option, setOption] = useState(initOption);
    const [errors, setErrors] = useState<string[]>([]);
    const [bad, setBad] = useState<{ [key: string]: boolean }>({});
    const [saving, setSaving] = useState(false);

    const parsed = url.trim() ? parseCoupang(url.trim()) : null;
    const vendorItemId = parsed && !parsed.err ? (parsed.vendorItemId || manualId.trim()) : "";
    const idChanged = !!vendorItemId && vendorItemId !== item.id;
    // 다른 물품으로 이미 등록된 옵션 ID 면 저장 불가
    const isDup = idChanged && props.existingIds.has(vendorItemId);

    const submit = async (e: any) => {
        e.preventDefault();
        const err: string[] = [];
        const nextBad: { [key: string]: boolean } = {};
        if (!url.trim()) { err.push("쿠팡 상품 링크를 넣어 주세요"); nextBad.url = true; }
        else if (parsed && parsed.err) { err.push(parsed.err); nextBad.url = true; }
        else if (!/^\d{1,20}$/.test(vendorItemId)) { err.push("옵션 ID(vendorItemId)가 필요합니다"); nextBad.id = true; }
        if (isDup) err.push(`옵션 ID ${vendorItemId}는 이미 다른 물품으로 등록되어 있습니다`);
        if (!name.trim()) { err.push("물품명을 입력해 주세요"); nextBad.name = true; }
        if (!option.trim()) { err.push("옵션을 입력해 주세요"); nextBad.option = true; }
        setBad(nextBad);
        setErrors(err);
        if (err.length) return;

        // 바뀐 게 없으면 저장 없이 닫기
        if (url.trim() === (item.url || "") && !idChanged && name.trim() === initName && option.trim() === initOption) {
            props.onClose();
            return;
        }

        setSaving(true);
        try {
            const result: any = await postFetch("/api/branch-orders/admin/product-edit", {
                vendorItemId: item.id, url: url.trim(), newVendorItemId: vendorItemId, name: name.trim(), option: option.trim(),
            });
            if (result.message === "success") {
                toast.success(`"${name.trim()}" 수정${idChanged ? ` — 옵션 ID ${item.id} → ${vendorItemId}` : ""}`);
                props.onSaved();
            } else {
                setErrors([SERVER_ERRORS[result.message] || `수정 실패 (${result.message})`]);
            }
        } catch (e) {
            console.log(e);
            setErrors(["수정 실패 — 잠시 후 다시 시도해 주세요"]);
        }
        setSaving(false);
    }

    return (
        <div className={styles.overlay} onClick={(e) => { if (e.target === e.currentTarget && !saving) props.onClose(); }}>
            <div className={`${styles.modal} ${styles.wide}`} role="dialog" aria-modal="true" aria-labelledby="branchOrderEditTitle">
                <div className={styles.modalHeader} id="branchOrderEditTitle">물품 수정 · 옵션 ID <span className={styles.num}>{item.id}</span></div>
                <form id="branchOrderEditForm" className={styles.mb} noValidate onSubmit={submit}>
                    <div className={styles.f}>
                        <label htmlFor="boEditUrl">쿠팡 상품 링크 <span className={styles.req}>필수</span></label>
                        <input id="boEditUrl" type="url" className={bad.url || (parsed && parsed.err) ? styles.bad : ""} autoFocus autoComplete="off"
                            placeholder="https://www.coupang.com/vp/products/…?itemId=…&vendorItemId=…" value={url} onChange={(e) => setUrl(e.target.value)} />
                        <div className={styles.fh}>판매 중단 등으로 바꿀 때는 쿠팡에서 <b>대체 상품의 옵션을 고른 뒤</b> 주소를 복사해 붙여 주세요. 옵션 ID(vendorItemId)가 들어 있어야 선배봇이 같은 옵션을 주문합니다.</div>
                        {
                            parsed && !parsed.err && parsed.vendorItemId ?
                                <div className={styles.idline}>
                                    <span className={styles.mini}>옵션 ID</span> <span className={styles.num}>{parsed.vendorItemId}</span>
                                    {isDup ? <span className={styles.dup}>이미 다른 물품으로 등록된 옵션입니다</span>
                                        : idChanged ? <span className={styles.fh}>옵션 ID가 바뀝니다 ({item.id} → {parsed.vendorItemId}) · 지점 노출 설정은 그대로 유지됩니다</span> : null}
                                </div>
                                : null
                        }
                    </div>
                    {
                        parsed && !parsed.err && !parsed.vendorItemId ?
                            <div className={styles.f}>
                                <label htmlFor="boEditId">옵션 ID (vendorItemId) 직접 입력</label>
                                <input id="boEditId" type="text" inputMode="numeric" className={bad.id ? styles.bad : ""} placeholder="예) 91953657904" autoComplete="off" value={manualId} onChange={(e) => setManualId(e.target.value)} />
                                <div className={styles.fh}>링크에 옵션 ID가 없습니다. 상품 페이지에서 옵션을 선택하면 주소에 vendorItemId가 생깁니다.{isDup ? <span className={styles.dup}> 이미 다른 물품으로 등록된 옵션입니다</span> : null}</div>
                            </div>
                            : null
                    }
                    <div className={styles.frow}>
                        <div className={styles.f}><label htmlFor="boEditName">물품명 <span className={styles.req}>필수</span></label><input id="boEditName" type="text" className={bad.name ? styles.bad : ""} autoComplete="off" value={name} onChange={(e) => setName(e.target.value)} /></div>
                        <div className={styles.f}><label htmlFor="boEditOpt">옵션 <span className={styles.req}>필수</span></label><input id="boEditOpt" type="text" className={bad.option ? styles.bad : ""} autoComplete="off" value={option} onChange={(e) => setOption(e.target.value)} /><div className={styles.fh}>쿠팡 옵션 표기 그대로 (수량·색상·용량)</div></div>
                    </div>
                    <div className={styles.fh}>이미 접수된 주문 내역은 옛 물품명·링크 그대로 남습니다.</div>
                    {errors.length ? <div className={styles.ferr}>{errors.map((m) => <div key={m}>{m}</div>)}</div> : null}
                </form>
                <div className={styles.modalFooter}>
                    <button type="button" className={styles.btn} disabled={saving} onClick={props.onClose}>취소</button>
                    <button type="submit" form="branchOrderEditForm" className={`${styles.btn} ${styles.primary}`} disabled={saving}>{saving ? "저장 중…" : "저장"}</button>
                </div>
            </div>
        </div>
    );
}

export default EditProductModal;
